package br.com.texeratx.boardgametimeapp.ui.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.heightIn
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.ModalBottomSheet
import androidx.compose.material3.Text
import androidx.compose.material3.TextField
import androidx.compose.material3.rememberModalBottomSheetState
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import br.com.texeratx.boardgametimeapp.core.i18n.LocalStrings
import br.com.texeratx.boardgametimeapp.ui.screens.games.model.CatalogGameUI

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun CatalogSearchBottomSheet(
    query: String,
    results: List<CatalogGameUI>,
    isSearching: Boolean,
    onQueryChange: (String) -> Unit,
    onPick: (CatalogGameUI) -> Unit,
    onDismiss: () -> Unit
) {
    val S = LocalStrings.current
    val sheetState = rememberModalBottomSheetState(skipPartiallyExpanded = true)

    ModalBottomSheet(
        onDismissRequest = onDismiss,
        sheetState = sheetState
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 16.dp)
                .padding(bottom = 16.dp)
        ) {
            Text(
                text = S.catalogSearchTitle,
                style = MaterialTheme.typography.titleMedium,
                fontWeight = FontWeight.Bold,
                modifier = Modifier.padding(bottom = 8.dp)
            )

            TextField(
                value = query,
                onValueChange = onQueryChange,
                label = { Text(S.catalogSearchHint) },
                modifier = Modifier.fillMaxWidth(),
                singleLine = true
            )

            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .heightIn(min = 120.dp, max = 480.dp)
                    .padding(top = 12.dp),
                contentAlignment = Alignment.TopCenter
            ) {
                when {
                    isSearching -> CircularProgressIndicator(modifier = Modifier.size(28.dp))
                    results.isEmpty() -> Text(
                        text = if (query.isBlank()) S.catalogSearchTypePrompt else S.catalogSearchNoResults,
                        style = MaterialTheme.typography.bodyMedium
                    )
                    else -> LazyColumn(
                        modifier = Modifier.fillMaxWidth().fillMaxHeight(),
                        verticalArrangement = Arrangement.spacedBy(4.dp)
                    ) {
                        items(results, key = { it.id }) { item ->
                            Row(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .clip(RoundedCornerShape(8.dp))
                                    .clickable { onPick(item) }
                                    .padding(8.dp),
                                verticalAlignment = Alignment.CenterVertically,
                                horizontalArrangement = Arrangement.spacedBy(12.dp)
                            ) {
                                GameThumb(
                                    imageUrl = item.imageUrl,
                                    contentDescription = item.name,
                                    modifier = Modifier.size(48.dp).clip(RoundedCornerShape(6.dp))
                                )
                                Column(modifier = Modifier.fillMaxWidth()) {
                                    Text(
                                        text = item.name,
                                        style = MaterialTheme.typography.bodyLarge,
                                        fontWeight = FontWeight.Medium
                                    )
                                    val subtitle = buildString {
                                        item.yearPublished?.let { append(it) }
                                        item.categoryName?.let {
                                            if (isNotEmpty()) append(" \u00b7 ")
                                            append(it)
                                        }
                                    }
                                    if (subtitle.isNotBlank()) {
                                        Text(
                                            text = subtitle,
                                            style = MaterialTheme.typography.bodySmall,
                                            color = MaterialTheme.colorScheme.onSurfaceVariant
                                        )
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
